import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const RtoMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9.]/g, "");
  const [EffectiveDate, setEffectiveDate] = useState("");
  const [CloseDate, setCloseDate] = useState("");
  const [VEHICLECCFROM, setVEHICLECCFROM] = useState("0");
  const [VEHICLECCTO, setVEHICLECCTO] = useState("0");
  const [EXSHOWROOMFROM, setEXSHOWROOMFROM] = useState("0");
  const [EXSHOWROOMTO, setEXSHOWROOMTO] = useState("0");
  const editId = location.state?.editId || "";
  const ViewId = location.state?.ViewId || "";
  const copyData = location.state?.copyData || null;
  const [RTORATE, setRTORATE] = useState("0");
  const [RTOSURCHARGE, setRTOSURCHARGE] = useState("0");
  const [RTOOTHER, setRTOOTHER] = useState("0");
  const [HPN, setHPN] = useState("0");
  const [GREENTAX, setGREENTAX] = useState("0");
  const [SMARTCARD, setSMARTCARD] = useState("0");
  const [REGISTRATIONFEE, setREGISTRATIONFEE] = useState("0");
  const [DUPLICATECARD, setDUPLICATECARD] = useState("0");
  const [NUMBERPLATE, setNUMBERPLATE] = useState("0");
  const [CNGKITCHARGE, setCNGKITCHARGE] = useState("0");
  const [TEMPFEE, setTEMPFEE] = useState("0");
  const [OTHERCHARGE, setOTHERCHARGE] = useState("0");
  const [BHRTOYEAR, setBHRTOYEAR] = useState("0");
  const [Vehiclecount, setVehiclecount] = useState("0");
  const [McdCharges, setMcdCharges] = useState("0");
  const [RoadSafety, setRoadSafety] = useState("0");
  const [Localtax, setLocaltax] = useState("0");
  const [EXCLUDINGTAXCHECKDED, setEXCLUDINGTAXCHECKDED] = useState(false);
  const [errors, setErrors] = useState({});
  const mode = copyData ? "copy" : editId ? "edit" : ViewId ? "view" : "add";
  const [StateList, setStateList] = useState([]);
  const [State, setState] = useState("");
  const [RTOTYPE, setRTOTYPE] = useState("");
  const [BranchList, setBranchList] = useState([]);
  const [Branch, setBranch] = useState("");
  const [Wheeltype, setWheeltype] = useState("");
  const [Fueltype, setFueltype] = useState("");
  const [TYPE, setTYPE] = useState("");
  const [loading, setLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("");

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "45px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "45px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const stateOptions = StateList.map((s) => ({
    label: s.label,
    value: s.value,
  }));
  const branchOptions = BranchList.map((b) => ({
    label: b.label,
    value: b.value,
  }));
  const rtoTypeOptions = [
    { label: "IN House", value: "inhouse" },
    { label: "OUT House", value: "outhouse" },
    { label: "BH", value: "bh" },
  ];

  const wheelTypeOptions = [
    { label: "TWO", value: "two" },
    { label: "THREE", value: "three" },
    { label: "FOUR", value: "four" },
  ];

  const fuelTypeOptions = [
    { label: "PETROL", value: "PETROL" },
    { label: "DIESEL", value: "DIESEL" },
    { label: "CNG PETROL", value: "CNG PETROL" },
    { label: "CNG DIESEL", value: "CNG DIESEL" },
    { label: "BIO DIESEL", value: "BIO DIESEL" },
    { label: "EV", value: "EV" },
  ];

  const typeOptions = [
    { label: "COMPANY", value: "1" },
    { label: "INDIVIDUAL", value: "2" },
  ];

  const inputStyle = (error) => ({
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "14px",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  useEffect(() => {
    fetchStateList();
    fetchBranchList();
  }, []);

  useEffect(() => {
    fetchStateList();
    fetchBranchList();
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const fetchBranchList = async () => {
    try {
      const response = await apiFetch(
        "/api/RtoMaster/branches",
        {
          method: "POST",
          body: JSON.stringify({
            userId: storedUserInfo.userId,
            companyCode: storedUserInfo.companyCode,
            propertyCode: storedUserInfo.propertyCode,
          }),
        },
      );
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setBranchList(data);
      }
    } catch (error) {
      console.error("❌ Error fetching branch list:", error);
    }
  };

  const fetchStateList = async () => {
    try {
      const response = await apiFetch(
        "/api/RtoMaseter/states",
        { method: "POST" },
      );
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setStateList(data);
      }
    } catch (error) {
      console.error("❌ Error fetching state list:", error);
    }
  };

  const handleExit = () => {
    navigate("/RtoMasterGrid");
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const payload = {
        userId: storedUserInfo.userId,
        ipAddress: ipAddress,
        serverIp: window.location.hostname,
        State,
        RTOTYPE,
        Branch,
        Wheeltype,
        EffectiveDate,
        CloseDate,
        Fueltype,
        VEHICLECCFROM,
        VEHICLECCTO,
        EXSHOWROOMFROM,
        EXSHOWROOMTO,
        EXCLUDINGTAXCHECKDED,
        RTORATE,
        RTOSURCHARGE,
        RTOOTHER,
        HPN,
        GREENTAX,
        SMARTCARD,
        REGISTRATIONFEE,
        DUPLICATECARD,
        NUMBERPLATE,
        CNGKITCHARGE,
        TEMPFEE,
        OTHERCHARGE,
        BHRTOYEAR,
        Vehiclecount,
        McdCharges,
        RoadSafety,
        Localtax,
        TYPE,
      };

      const response = await apiFetch(
        "/api/RtoMaseter/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.success) {
        alert("✅ RTO Master saved successfully!");
        navigate("/RtoMasterGrid");
      } else {
        alert("⚠️ " + data.message);
      }
    } catch (err) {
      console.error("❌ Error saving RTO master:", err);
      alert("❌ Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!editId) return;
    const fetchEditData = async () => {
      try {
        setLoading(true);
        const resp = await apiFetch(
          `/api/RtoMaster/Edit/${editId}`,
        );
        const d = await resp.json();
        if (!d || d.err === "1") {
          alert("No Record Found for editing!");
          return;
        }
        setWheeltype(d.wheeltype || "");
        setEffectiveDate(d.effectivedate || "");
        setCloseDate(d.closedate || "");
        setVEHICLECCFROM(d.vehiclefrom || "0");
        setVEHICLECCTO(d.vehicleto || "0");
        setEXSHOWROOMFROM(d.exshowroomfrom || "0");
        setEXSHOWROOMTO(d.exshowroomto || "0");
        setBranch(d.branchcode || "");
        setState(d.state || "");
        setRTOTYPE(d.rtotype || "");
        setFueltype(d.fuel || "");
        setEXCLUDINGTAXCHECKDED(d.extax === "t" || d.extax === "true");
        setRTORATE(d.rtorate || "0");
        setRTOSURCHARGE(d.rtosurcharge || "0");
        setRTOOTHER(d.rtoother || "0");
        setHPN(d.hpn || "0");
        setGREENTAX(d.greentax || "0");
        setSMARTCARD(d.smartcard || "0");
        setREGISTRATIONFEE(d.regfee || "0");
        setDUPLICATECARD(d.dupcard || "0");
        setNUMBERPLATE(d.numplate || "0");
        setCNGKITCHARGE(d.cngkitcharge || "0");
        setTEMPFEE(d.tempfee || "0");
        setOTHERCHARGE(d.othercharge || "0");
        setBHRTOYEAR(d.bhrtoyear || "0");
        setVehiclecount(d.vehiclecount || "0");
        setMcdCharges(d.mcdparkingcharge || "0");
        setTYPE(d.vtype || "");
        setRoadSafety(d.roadsafetytax || "0");
        setLocaltax(d.localtax || "0");
      } catch (err) {
        console.error("❌ Error fetching edit data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEditData();
  }, [editId]);

  useEffect(() => {
    if (!ViewId) return;
    const fetchEditData = async () => {
      try {
        setLoading(true);
        const resp = await apiFetch(
          `/api/RtoMaster/View/${ViewId}`,
        );
        const d = await resp.json();
        if (!d || d.err === "1") {
          alert("No Record Found for View!");
          return;
        }
        setWheeltype(d.wheeltype || "");
        setEffectiveDate(d.effectivedate || "");
        setCloseDate(d.closedate || "");
        setVEHICLECCFROM(d.vehiclefrom || "0");
        setVEHICLECCTO(d.vehicleto || "0");
        setEXSHOWROOMFROM(d.exshowroomfrom || "0");
        setEXSHOWROOMTO(d.exshowroomto || "0");
        setBranch(d.branchcode || "");
        setState(d.state || "");
        setRTOTYPE(d.rtotype || "");
        setFueltype(d.fuel || "");
        setEXCLUDINGTAXCHECKDED(d.extax === "t" || d.extax === "true");
        setRTORATE(d.rtorate || "0");
        setRTOSURCHARGE(d.rtosurcharge || "0");
        setRTOOTHER(d.rtoother || "0");
        setHPN(d.hpn || "0");
        setGREENTAX(d.greentax || "0");
        setSMARTCARD(d.smartcard || "0");
        setREGISTRATIONFEE(d.regfee || "0");
        setDUPLICATECARD(d.dupcard || "0");
        setNUMBERPLATE(d.numplate || "0");
        setCNGKITCHARGE(d.cngkitcharge || "0");
        setTEMPFEE(d.tempfee || "0");
        setOTHERCHARGE(d.othercharge || "0");
        setBHRTOYEAR(d.bhrtoyear || "0");
        setVehiclecount(d.vehiclecount || "0");
        setMcdCharges(d.mcdparkingcharge || "0");
        setTYPE(d.vtype || "");
        setRoadSafety(d.roadsafetytax || "0");
        setLocaltax(d.localtax || "0");
      } catch (err) {
        console.error("❌ Error fetching View data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEditData();
  }, [ViewId]);

  useEffect(() => {
    if (!copyData) return;
    setEffectiveDate(copyData.effectivedate || "");
    setCloseDate(copyData.closedate || "");
    setState(copyData.state || "");
    setRTOTYPE(copyData.rtotype || "");
    setBranch(copyData.branchcode || "");
    setWheeltype(copyData.wheeltype || "");
    setFueltype(copyData.fuel || "");
    setVEHICLECCFROM(copyData.vehiclefrom || "0");
    setVEHICLECCTO(copyData.vehicleto || "0");
    setEXSHOWROOMFROM(copyData.exshowroomfrom || "0");
    setEXSHOWROOMTO(copyData.exshowroomto || "0");

    setEXCLUDINGTAXCHECKDED(
      copyData.extax === "t" || copyData.extax === "true",
    );
    setRTORATE(copyData.rtorate || "0");
    setRTOSURCHARGE(copyData.rtosurcharge || "0");
    setRTOOTHER(copyData.rtoother || "0");
    setHPN(copyData.hpn || "0");
    setGREENTAX(copyData.greentax || "0");
    setSMARTCARD(copyData.smartcard || "0");
    setREGISTRATIONFEE(copyData.regfee || "0");
    setDUPLICATECARD(copyData.dupcard || "0");
    setNUMBERPLATE(copyData.numplate || "0");
    setCNGKITCHARGE(copyData.cngkitcharge || "0");
    setTEMPFEE(copyData.tempfee || "0");
    setOTHERCHARGE(copyData.othercharge || "0");
    setBHRTOYEAR(copyData.bhrtoyear || "0");
    setVehiclecount(copyData.vehiclecount || "0");
    setMcdCharges(copyData.mcdparkingcharge || "0");
    setRoadSafety(copyData.roadsafetytax || "0");
    setLocaltax(copyData.localtax || "0");
    setTYPE(copyData.vtype || "");
  }, [copyData]);

  const handleUpdate = async () => {
    if (!editId) {
      alert("Edit ID missing!");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        editId,
        userId: storedUserInfo.userId,
        ipAddress: "192.168.1.10",
        serverIp: "192.168.1.100",
        State,
        RTOTYPE,
        Branch,
        Wheeltype,
        EffectiveDate,
        CloseDate,
        Fueltype,
        VEHICLECCFROM,
        VEHICLECCTO,
        EXSHOWROOMFROM,
        EXSHOWROOMTO,
        EXCLUDINGTAXCHECKDED,
        RTORATE,
        RTOSURCHARGE,
        RTOOTHER,
        HPN,
        GREENTAX,
        SMARTCARD,
        REGISTRATIONFEE,
        DUPLICATECARD,
        NUMBERPLATE,
        CNGKITCHARGE,
        TEMPFEE,
        OTHERCHARGE,
        BHRTOYEAR,
        Vehiclecount,
        McdCharges,
        RoadSafety,
        Localtax,
        TYPE,
      };
      const res = await apiFetch(
        "/api/RtoMaseter/update",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      if (data.success) {
        alert("Updated Successfully!");
        navigate("/RtoMasterGrid");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="page-container-imd">
        <div className="container-imd">
          <div className="header-imd">Rto Master</div>
          <div className="form-grid-imd">
            <div className="form-item-imd">
              <label>STATE</label>
              <Select
                options={stateOptions}
                value={stateOptions.find((o) => o.value === State) || null}
                onChange={(selected) => setState(selected?.value || "")}
                styles={customSelectStyles}
                placeholder="Select State"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>RTO TYPE</label>
              <Select
                options={rtoTypeOptions}
                value={rtoTypeOptions.find((o) => o.value === RTOTYPE) || null}
                onChange={(s) => setRTOTYPE(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select RTO Type"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>BRANCH</label>
              <Select
                options={branchOptions}
                value={branchOptions.find((o) => o.value === Branch) || null}
                onChange={(selected) => setBranch(selected?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Branch"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>WHEEL TYPE</label>
              <Select
                options={wheelTypeOptions}
                value={
                  wheelTypeOptions.find((o) => o.value === Wheeltype) || null
                }
                onChange={(s) => setWheeltype(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Wheel Type"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>EFFECTIVE DATE</label>
              <input
                type="date"
                className="input-imd"
                value={EffectiveDate}
                onChange={(e) => setEffectiveDate(e.target.value)}
              />
            </div>
            <div className="form-item-imd">
              <label>CLOSE DATE</label>
              <input
                type="date"
                className="input-imd"
                value={CloseDate}
                onChange={(e) => setCloseDate(e.target.value)}
              />
            </div>
            <div className="form-item-imd">
              <label>FUEL TYPE</label>
              <Select
                options={fuelTypeOptions}
                value={
                  fuelTypeOptions.find((o) => o.value === Fueltype) || null
                }
                onChange={(s) => setFueltype(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Fuel Type"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>VEHICLE CC FROM</label>
              <input
                type="number"
                className="input-imd"
                value={VEHICLECCFROM}
                onChange={(e) => setVEHICLECCFROM(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>VEHICLE CC TO</label>
              <input
                type="number"
                className="input-imd"
                value={VEHICLECCTO}
                onChange={(e) => setVEHICLECCTO(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>EX-SHOWROOM FROM</label>
              <input
                type="number"
                className="input-imd"
                value={EXSHOWROOMFROM}
                onChange={(e) =>
                  setEXSHOWROOMFROM(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>EX-SHOWROOM TO</label>
              <input
                type="number"
                className="input-imd"
                value={EXSHOWROOMTO}
                onChange={(e) => setEXSHOWROOMTO(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd checkbox-center">
              <label>EXCLUDING TAX</label>
              <input
                type="checkbox"
                checked={EXCLUDINGTAXCHECKDED}
                onChange={(e) => setEXCLUDINGTAXCHECKDED(e.target.checked)}
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                }}
              />
            </div>
            <div className="form-item-imd">
              <label>RTO RATE</label>
              <input
                type="number"
                className="input-imd"
                value={RTORATE}
                onChange={(e) => setRTORATE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>RTO SURCHARGE</label>
              <input
                type="number"
                className="input-imd"
                value={RTOSURCHARGE}
                onChange={(e) => setRTOSURCHARGE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>RTO OTHER</label>
              <input
                type="number"
                className="input-imd"
                value={RTOOTHER}
                onChange={(e) => setRTOOTHER(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>HPN</label>
              <input
                type="number"
                className="input-imd"
                value={HPN}
                onChange={(e) => setHPN(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>GREEN TAX</label>
              <input
                type="number"
                className="input-imd"
                value={GREENTAX}
                onChange={(e) => setGREENTAX(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>SMART CARD</label>
              <input
                type="number"
                className="input-imd"
                value={SMARTCARD}
                onChange={(e) => setSMARTCARD(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>REGISTRATION FEE</label>
              <input
                type="number"
                className="input-imd"
                value={REGISTRATIONFEE}
                onChange={(e) =>
                  setREGISTRATIONFEE(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-item-imd">
              <label>DUPLICATE CARD</label>
              <input
                type="number"
                className="input-imd"
                value={DUPLICATECARD}
                onChange={(e) => setDUPLICATECARD(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>NUMBER PLATE</label>
              <input
                type="number"
                className="input-imd"
                value={NUMBERPLATE}
                onChange={(e) => setNUMBERPLATE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>CNG KIT CHARGE</label>
              <input
                type="number"
                className="input-imd"
                value={CNGKITCHARGE}
                onChange={(e) => setCNGKITCHARGE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>TEMP FEE</label>
              <input
                type="number"
                className="input-imd"
                value={TEMPFEE}
                onChange={(e) => setTEMPFEE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>OTHER CHARGE</label>
              <input
                type="number"
                className="input-imd"
                value={OTHERCHARGE}
                onChange={(e) => setOTHERCHARGE(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>BH RTO YEAR</label>
              <input
                type="number"
                className="input-imd"
                value={BHRTOYEAR}
                onChange={(e) => setBHRTOYEAR(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>VEHICLE COUNT</label>
              <input
                type="number"
                className="input-imd"
                value={Vehiclecount}
                onChange={(e) => setVehiclecount(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>MCD CHARGE</label>
              <input
                type="number"
                className="input-imd"
                value={McdCharges}
                onChange={(e) => setMcdCharges(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>TYPE</label>
              <Select
                options={typeOptions}
                value={typeOptions.find((o) => o.value === TYPE) || null}
                onChange={(s) => setTYPE(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Type"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-item-imd">
              <label>ROAD SAFETY TAX</label>
              <input
                type="number"
                className="input-imd"
                value={RoadSafety}
                onChange={(e) => setRoadSafety(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-item-imd">
              <label>LOCAL TAX</label>
              <input
                type="number"
                className="input-imd"
                value={Localtax}
                onChange={(e) => setLocaltax(allowNumbers(e.target.value))}
              />
            </div>
          </div>
          <div style={buttonContainerStyle}>
            {/* ADD or COPY MODE → Save + Exit */}
            {(mode === "add" || mode === "copy") && (
              <>
                <button
                  style={buttonStyle("#4caf50")}
                  type="button"
                  onClick={handleSave}
                >
                  Save
                </button>
                <button
                  style={buttonStyle("#ab2025")}
                  type="button"
                  onClick={handleExit}
                >
                  Exit
                </button>
              </>
            )}

            {/* EDIT MODE → Update + Exit */}
            {mode === "edit" && (
              <>
                <button
                  style={buttonStyle("#2e20abff")}
                  type="button"
                  onClick={handleUpdate}
                >
                  Update
                </button>
                <button
                  style={buttonStyle("#ab2025")}
                  type="button"
                  onClick={handleExit}
                >
                  Exit
                </button>
              </>
            )}

            {/* VIEW MODE → Only Exit */}
            {mode === "view" && (
              <button
                className="btn exit-btn"
                type="button"
                onClick={handleExit}
              >
                Exit
              </button>
            )}
          </div>
        </div>
      </div>

      {/* ✅ UPDATED RESPONSIVE CSS */}
      <style>{`
  .rs__menu-portal {
  z-index: 9999 !important;
}

/* ===== PAGE ===== */
.page-container-imd {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.container-imd {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
}

/* ===== HEADER ===== */
.header-imd {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== FORM GRID ===== */
.form-grid-imd {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
}

.form-item-imd {
  display: flex;
  flex-direction: column;
}

.form-item-imd label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.input-imd,
.form-item-imd select {
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
}

/* Checkbox align */
.form-item-imd.checkbox-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-direction: row;
}

/* ===== BUTTONS ===== */
.button-row-imd {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.btn {
  width: 120px;
  padding: 12px 0;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}

.save-btn { background: #4caf50; }
.exit-btn { background: #ab2025; }

/* ===== RESPONSIVE ===== */
@media (max-width: 1200px) {
  .form-grid-imd {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .form-grid-imd {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .form-grid-imd {
    grid-template-columns: 1fr;
  }
}

      `}</style>
    </Layout>
  );
};

export default RtoMasterDetailsDesign;
